import DirectionController from './direction.controller';
import * as _ from 'lodash';

export default (ngModule) => {

  ngModule
    .directive('direction', function direction() {
      return {
        restrict: 'E',
        transclude: true,
        template: '<div class="mapa-component"><i class="icon ion-wifi assertive"></i></div>',
        scope: {
          origem: '=',
          destino: '=',
          waypoints: '='
        },
        controller: DirectionController,
        controllerAs: 'vm',
        bindToController: true,
        link: link
      };

      function link(scope, elem) {
        scope.vm = _.assign(scope.vm, {elem: elem.children()[0]});
      }
    });
};



/** WEBPACK FOOTER **
 ** ../~/tslint-loader!./common/components/mapa/direction.directive.ts
 **/